exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#habitaciones {\n  padding: 0;\n}\n#habitaciones .table {\n  margin: -1px 0 0;\n}\n#habitaciones .table > tbody > tr > th,\n#habitaciones .table > tbody > tr > td {\n  height: 41px;\n  padding: 5px 10px;\n  vertical-align: middle;\n}", ""]);

// exports
